(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("hyphaWebsocketClient", [], factory);
	else if(typeof exports === 'object')
		exports["hyphaWebsocketClient"] = factory();
	else
		root["hyphaWebsocketClient"] = factory();
})(window, function() {
return 